export const editorConfigEn = {
  buttons: [
    "bold",
    "italic",
    "underline",
    "undo",
    "ul",
    "ol",
    "indent",
    "outdent",
  ],
  placeholder: "Type here",
  // askBeforePasteHTML: false,
  // forcePlainText: true,
  enter: "div",
  defaultActionOnPasteFromWord: "insert_only_text",
  defaultActionOnPaste: "insert_only_text",
  sanitize: function (text) {
    // Remove HTML tags from text
    return text.replace(/<[^>]*>/g, "");
  },
  // enter: "br",
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  askBeforePasteFromWord: true,
  askBeforePasteHTML: true,
};

export const editorAllConfigEn = {
  buttons: [
    "source",
    "fullsize",
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "eraser",
    "superscript",
    "subscript",
    "|",
    "ul",
    "ol",
    "indent",
    "outdent",
    "|",
    "left",
    "center",
    "right",
    "justify",
    "|",
    "font",
    "fontsize",
    "paragraph",
    "classSpan",
    "|",
    "brush",
    "color",
    "background",
    "|",
    "link",
    "unlink",
    "image",
    "video",
    "table",
    "file",
    "|",
    "hr",
    "symbol",
    "emoji",
    "|",
    "undo",
    "redo",
    "cut",
    "copy",
    "paste",
    "selectall",
    "print",
  ],
  toolbarAdaptive: false,
  toolbarSticky: true,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  defaultActionOnPaste: "insert_only_text",
  defaultActionOnPasteFromWord: "insert_only_text",
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  placeholder: "Type here",
  enter: "div",
  useSplitMode: false,
  cleanHTML: {
    removeTags: ["script", "style"],
    allowTags: [
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "b",
      "i",
      "u",
      "a",
      "img",
      "ul",
      "ol",
      "li",
      "br",
      "strong",
      "em",
      "table",
      "tr",
      "td",
      "th",
      "thead",
      "tbody",
      "tfoot",
      "div",
      "span",
    ],
  },
  sanitize: function (text) {
    return text.replace(/<[^>]*>/g, ""); // strip HTML if needed
  },
};
